import React from 'react';
import { withRouter } from 'react-router-dom';

//HELPERS
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { listaAction } from '../../store/lista';

//COMPONENTS
import { Row, Column, IBox, Title, Content, Button, Return, Select, Icon } from '../inspinia'
import ModalSucesso from './modalSucessoLista'
import SelectMultiSelect from 'react-select';
import TableDinamica from './tableVisualizacao';
import CircularProgress from '@material-ui/core/CircularProgress';

class ListaMapearValidar extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            selectedOption: this.props.location.state.response.colunas.results,
            loading: false,
            filter: "",
            page: 0,
            quantidadeCombo: this.props.location.state.response.quantidadeCampos,
            isLoggedIn: true,

            form: this.formInitialState(),

            comboColunas: {
                results: undefined
            },
            comboCampo: {
                results: undefined
            },
            list: {
                currentPage: 1,
                pageCount: 0,
                pageSize: 0,
                rowCount: 0,
                results: undefined
            },
            arquivo: this.props.location.state.response.contatosExibicao,
            colunas: this.props.location.state.response.colunas.results,
            arquivoCompleto: this.props.location.state.response.contatos,
            listaVisualizacao: null,
            modalSucessoIsOpen: false,
            emailUsuario: this.props.auth.user.email,
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeSelectMulti = this.handleChangeSelectMulti.bind(this);
        this.handleSucessoToggle = this.handleSucessoToggle.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleCombinarCampos = this.handleCombinarCampos.bind(this);

    }



    formInitialState() {
        return {
        responseUpload: this.props.location.state.response,
        tagSelecionadas: [],
        contatosArquivo: [],
        tipoListaContato: this.props.location.state.response.tipoLista,
    }
    }

    handleCombinarCampos(e) {

        const form = this.state.form;

        this.state.isLoggedIn = true;

        this.setState({ form: { ...form, [e.target.name]: e.target.value } });
    }

    handleChange(e) {
        const form = this.state.form;

        this.state.isLoggedIn = false;

        this.setState({ form: { ...form, [e.target.name]: e.target.value } });
    }

    handleChangeSelectMulti(selectedOption) {

        this.state.isLoggedIn = false;

        this.setState({ selectedOption });

    }

    handleSucessoToggle(e) {
        this.setState({ ...this.state, modalSucessoIsOpen: !this.state.modalSucessoIsOpen });
    }

    handleSave(e) {
        e.preventDefault();

    this.state.form.tagSelecionadas = this.state.selectedOption;
    this.state.form.contatosArquivo = this.DesagruparListaAPI(this.state.arquivo);
    this.state.form.emailUsuario = this.state.emailUsuario;

    this.setState({ ...this.state, loading: true });

    this.props.actions.lista.importar(this.state.form)
        .then((response) => {
            this.setState({ ...this.state, loading: false });

            if (response.ok) {
                this.handleSucessoToggle();
            } else {
                const msg = response.data && (response.data.message || response.data.mensagem);
                c.TOASTER_ERROR(msg || 'Erro ao importar lista de contatos.');
            }
        })
        .catch((error) => {
            if (error && error.message) {
                c.TOASTER('error', error.message);
            } else {
                c.TOASTER_ERROR(c.NETWORK_ERROR);
            }
        });
    }

    LoadColunasValue(lista) {
    return this.DesagruparListaAPI(lista);
}

    DesagruparListaAPI(lista) {
        const values = [];
        lista.forEach(item => {
            const person = [];
            Object.values(item).forEach(value => {
                if (Array.isArray(value)) {
                    let tags = value.flat();
                    tags.forEach(function (item) {
                        person.push(item.valor);
                    });
                } else {
                    if (value !== null) {
                        person.push(value);
                    }
                }
            });
            values.push(person);
        });

        return values;
    }


    render() {

        let table;
        const isLoggedIn = this.state.isLoggedIn;

        if (isLoggedIn) {
            const headFilter = this.LoadFilter(this.state.selectedOption);
            const valores = this.LoadColunasValue(this.state.arquivo);
            const cabecalho = this.LoadCabecalho(this.props.location.state.response.colunas.results);

            table = (
                <TableDinamica
                    headTable={cabecalho}
                    valuesTable={valores}
                    headFilter={headFilter}
                />
            );
        }


        return (
            <div>
                <ModalSucesso isOpen={this.state.modalSucessoIsOpen} toggle={this.handleSucessoToggle} />

                {/* MAIN CONTENT */}
                <Row className="mb-5">
                    <Column>
                        <IBox>
                            <Title className="pt-5 text-center">
                                <h2 className="fs-20 fw-600 text-body">Combinar campos</h2>

                                <h5 className="fs-14 fw-400 text-body">Combine os campos do seu arquivo com os campos do Sendmail, iremos mostrar 3 resultados como pré-visualização.</h5>
                            </Title>

                            <Content className="p-3 border-0">
                                {/* FORMULÁRIO */}
                                <Row className="m-0 mb-3">
                                    <Column size="9" className="container mx-auto p-0">

                                        <Row className="m-0 mb-3">

                                            <Column size="10" className="p-0 mx-auto container">

                                                <SelectMultiSelect
                                                    value={this.state.selectedOption}
                                                    onChange={this.handleChangeSelectMulti}
                                                    options={this.state.colunas}
                                                    isMulti='true'
                                                    placeholder='Selecione coluna' />

                                            </Column>

                                            <Column size="2" className="px-1">

                                                <Button onClick={this.handleCombinarCampos}><Icon name="fa-plus" /> </Button>

                                            </Column>

                                        </Row>

                                        <Row className="mt-4">

                                            <Column size="12" className="px-1 table-responsive">

                                                {table}

                                            </Column>

                                        </Row>

                                    </Column>
                                </Row>

                                {/* NAVEGAÇÃO */}
                                <Row className="m-0 mb-3">
                                    <Column size="auto" className="mx-auto">
                                        <div className="input-group">

                                            <Return to={c.CAMPAIGN_ROUTE + "/lista/validar"} className="mx-1" width="130px" />
                                            <Button onClick={this.handleSave} className="mx-1" width="130px">Importar</Button>

                                            <div className="ml-4">
                                                {this.state.loading && (
                                                    <CircularProgress
                                                        size={30}
                                                        thickness={4}
                                                        color='inherit'
                                                        variant='indeterminate' />
                                                )}
                                            </div>

                                        </div>
                                    </Column>

                                </Row>
                            </Content>
                        </IBox>
                    </Column>
                </Row>
            </div>
        );
    }


    LoadFilter(colunas) {
        const filter = [];

        colunas.forEach(function (item) {
            filter.push(item.label);
        });

        return filter;

    }

    LoadCabecalho(lista) {
        const cabecalhoOriginal = [];

        lista.forEach(function (item) {
            cabecalhoOriginal.push(item.label);
        });

        return cabecalhoOriginal;
    }

    LoadComboNome() {
        let self = this;

        const url = `${c.API_BASE_URL}/combo-nome`;
        const options = {
            method: 'GET' // method: 'POST'
            ,
            headers: { 'Content-Type': 'application/json' }
            //,body: JSON.stringify(user)
        };

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboNome: response });
        });
    }

    LoadComboCampo() {
        let self = this;

        const url = `${c.API_BASE_URL}/combo-campos`;
        const options = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        };

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboColunas: response });
        });
    }

    LoadTable() {
        let self = this;

        const url = `${c.API_BASE_URL}/campanha-lista-mapear`;
        const options = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        };

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, list: response });
        });
    }
}

class Table extends React.Component {
    render() {
        const data = this.props.data; let html = "";

        if (data.results === undefined) {
            html = (<tr><td colSpan="3" scope="row">Carregando...</td></tr>);
        }
        else if (data.results.length === 0) {
            html = (<tr><td colSpan="3" scope="row">Nenhum registro encontrado.</td></tr>);
        }
        else if (data.results.length > 0) {
            html = data.results.map(row =>
                <tr key={row.id} id={row.id}>
                    <td>{row.nome}</td>
                    <td>{row.email}</td>
                    <td>{row.telefone}</td>
                </tr>
            );
        }

        return (
            <table className="footable table table-striped toggle-arrow-tiny text-body">
                <thead>
                    <tr style={{ backgroundColor: "#dbf1e9" }}>
                        <th>Nome</th>
                        <th>E-mail</th>
                        <th>Telefone</th>
                    </tr>
                </thead>

                <tbody>{html}</tbody>
            </table>
        )
    }
}



class ColumnComboSelect extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = { quantidadeCombo: 0 }
    }

    handleChange(event) {
        alert(event.target.value)

    }

    render() {
        for (let index = 0; index < this.props.quantidadeCombo; index++) {

            return (
                <Column size="4" className="px-1">
                    <div className="input-group">
                        <Select name="campo2" placeholder="Selecione o campo" selected="" data={this.state.comboColunas} />
                    </div>
                </Column>
            );
        }
    }
}



function mapStateToProps(state) {
    return { auth: state.auth, lista: state.lista };
}

function mapDispatchToProps(dispatch) {
    return { actions: { lista: bindActionCreators(listaAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ListaMapearValidar));